"use strict";

exports.__esModule = true;

var shared_1 = require("./shared");

var CertificateParser =
/** @class */
function () {
  function CertificateParser() {}
  /**
   * Приводим ключи к единому виду
   */


  CertificateParser.replaceRDNKeys = function (rdn, schema) {
    return schema.reduce(function (tempRDN, item) {
      if (tempRDN[item.from]) {
        tempRDN[item.to] = tempRDN[item.from];
        delete tempRDN[item.from];
      }

      return tempRDN;
    }, rdn);
  };
  /**
   * Удаляем первые два нуля в ИНН, если они есть
   */


  CertificateParser.inn = function (subject) {
    var inn = subject['ИНН'];
    return inn ? inn.replace(/^00/, '') : '';
  };

  CertificateParser.kpp = function (subject, type) {
    if (type !== CertificateSubjectType.UL || subject['UN'] === undefined) {
      return '';
    }

    var un = subject['UN'];

    if (!un) {
      return '';
    }

    try {
      var arUn = [];
      var kpp = '';
      var reKppWithKey = /(\/?KPP=\d{9})|(\/?КПП=\d{9})/i;

      if (reKppWithKey.test(un)) {
        arUn = un.split('/');

        for (var i = 0, l = arUn.length; i < l; i++) {
          var item = arUn[i];

          if (item.indexOf('=') === -1) {
            continue;
          }

          var _a = item.split('='),
              key = _a[0],
              value = _a[1];

          if (['KPP', 'КПП'].includes(key)) {
            kpp = value;
            break;
          }
        }
      } else {
        arUn = un.split('-');
        kpp = arUn[1] || '';
      }

      return kpp;
    } catch (e) {
      return '';
    }
  };

  CertificateParser.subjectType = function (subject) {
    var ogrnip = subject['ОГРНИП'];

    if (ogrnip && /^0*$/.test(ogrnip) === false) {
      // иногда ОГРНИП задано но состоит из одних только нулей.
      return CertificateSubjectType.IP;
    }

    var inn = CertificateParser.inn(subject);

    if (inn && inn.length === 10) {
      return CertificateSubjectType.UL;
    }

    return CertificateSubjectType.FL;
  };

  CertificateParser.issuer = function (issuer) {
    return issuer['CN'] || '';
  };

  CertificateParser.organizationName = function (subject, subjectType) {
    var orgName = subject['ON'] || subject['O'];

    if (orgName) {
      return orgName;
    }

    return subjectType === CertificateSubjectType.IP ? "\u0418\u041F " + subject['CN'] : CertificateParser.owner(subject);
  };

  CertificateParser.owner = function (subject) {
    var personalName = [];
    var sn = subject['SN'];

    if (sn) {
      personalName.push(sn.replace('_', ' '));
    }

    var g = subject['G'];

    if (g) {
      personalName.push(g.replace('_', ' '));
    }

    var cn = subject['CN'] || '';
    return personalName.join(' ') || cn;
  };

  CertificateParser.licenseBuiltin = function (ext) {
    return !!(ext && ext[shared_1.OIDs.CRYPTO_PRO_LIMITED_LICENSE]);
  };

  CertificateParser.isCloud = function (ext) {
    return !!(ext && ext.extendedKeyUsages && ext.extendedKeyUsages[shared_1.OIDs.CONTUR_CLOUD_CRYPT]);
  };

  return CertificateParser;
}();

exports["default"] = CertificateParser;
var CertificateSubjectType;

(function (CertificateSubjectType) {
  CertificateSubjectType["UL"] = "\u042E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E";
  CertificateSubjectType["IP"] = "\u0418\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C";
  CertificateSubjectType["FL"] = "\u0424\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043B\u0438\u0446\u043E";
})(CertificateSubjectType = exports.CertificateSubjectType || (exports.CertificateSubjectType = {}));